export * from "/www/wwwroot/xoilactv.tech/node_modules/@fortawesome/react-fontawesome/index.es.js"